import service from "@/services/api";

const defaultState = () => {
  return {
    referrer: localStorage.referrer || "",
    verified: null,
    isLogin: false,
    statusCode: -1,
    loading: false,
    error: ""
  };
};

const state = defaultState();

const getters = {
  referrer: state => state.referrer,
  status: state => state.statusCode,
  verified: state => state.verified,
  isLogin: state => state.isLogin,
  error: state => state.error,
  isLoading: state => state.loading
};

const actions = {
  logIn({ commit }, credentials) {
    commit("setLoading", true);
    return service()
      .post("auth", credentials, {
        withCredentials: true
      })
      .then(res =>
        setTimeout(
          commit("setStateFromResponse", [true, res.status, true]),
          1000
        )
      )
      .catch(e => {
        const status = (e.response && e.response.status) || 500;
        commit("setStateFromResponse", [false, status, true]);
        commit(
          "setError",
          status === 500
            ? "Une erreur serveur est survenue"
            : "Veuillez vérifier vos identifiants de connexion."
        );
      })
      .finally(() => commit("setLoading", false));
  },

  async entry({ commit, dispatch }, referrer) {
    commit("referrer", referrer);
    localStorage.referrer = referrer;

    dispatch("verify");
  },

  async verify({ commit }) {
    commit("defaultState");
    return service()
      .get(process.env.VUE_APP_WINDU_BACK + "verify", {
        withCredentials: true
      })
      .then(res => {
        commit("setStateFromResponse", [true, res.status]);

        return true;
      })
      .catch(e => {
        if (e.response && e.response.status) {
          commit("setStateFromResponse", [false, e.response.status]);
        }

        return false;
      });
  },

  verifyRoutes({ commit }) {
    return service()
      .get(process.env.VUE_APP_WINDU_BACK + "verify", {
        withCredentials: true
      })
      .then(res => {
        commit("setStateFromResponse", [true, res.status]);

        return true;
      })
      .catch(e => {
        if (e.response && e.response.status) {
          commit("setStateFromResponse", [false, e.response.status]);
        }

        return false;
      });
  },

  logOut({ commit }) {
    service()
      .delete("auth", {
        withCredentials: true
      })
      .then(() => setTimeout(commit("defaultState"), 1000));
  },

  reinitialize({ commit }) {
    commit("defaultState");
  }
};

const mutations = {
  defaultState(state) {
    Object.assign(state, defaultState());
  },
  referrer(state, referrer) {
    state.referrer = referrer;
  },
  setStateFromResponse(state, [status, code, isLogin = false]) {
    state.verified = status;
    state.statusCode = parseInt(code);
    state.isLogin = isLogin;
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, status) {
    state.loading = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
